import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull/components/OverlayContext/OverlayContext';
import { draftsScopedToRun } from '~/pages/DraftsDashboard/bulkRunScope';
import { BulkCreateResultsModal } from '../../../../BulkCreateResultsModal/BulkCreateResultsModal';
import { TasksDrawerStoreContext, useTasksDrawer, useTasksDrawerStoreApi } from '../../../../tasksDrawerStore';
const runResultsPropsOf = (task)=>({
        runId: task.jobId,
        jobName: task.jobName,
        runCancelled: task.status === 'cancelled'
    });
const reviewRequestOf = (dismissModal, closeDrawer)=>()=>{
        closeDrawer();
        dismissModal(true);
    };
// WHY: overlay content mounts above the drawer-store provider, so the modal's send hook needs the drawer's store re-provided
const resultsOf = (props, drawerStore, closeDrawer)=>function RunResults(param) {
        let { dismissModal } = param;
        const onClose = ()=>dismissModal(false);
        const onReviewDrafts = reviewRequestOf(dismissModal, closeDrawer);
        return /*#__PURE__*/ _jsx(TasksDrawerStoreContext.Provider, {
            value: drawerStore,
            children: /*#__PURE__*/ _jsx(BulkCreateResultsModal, _object_spread_props(_object_spread({}, props), {
                onClose: onClose,
                onReviewDrafts: onReviewDrafts
            }))
        });
    };
export const useOpenCreateRunResults = (task)=>{
    const { showModal } = useOverlayContext();
    const { closeDrawer } = useTasksDrawer();
    const navigate = useNavigate();
    const drawerStore = useTasksDrawerStoreApi();
    const content = resultsOf(runResultsPropsOf(task), drawerStore, closeDrawer);
    return (event)=>{
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        void showModal({
            biName: 'bulk_create_results',
            content
        }).then((reviewRequested)=>{
            if (reviewRequested) navigate(draftsScopedToRun(task.jobId));
        });
    };
};
